import React from 'react';
import { GetLocationsTask } from '~admin/interactor/location/perform-get-locations';
import { LocationData } from '~admin/model/location-data';
import { SelectFieldTask } from '~admin/view/components/ui/form/fields/field-select-task.component';
import { SelectFieldOption } from '~common/components/select.component';

interface Props {
  name: string;
  label: string;
  task: GetLocationsTask;
  disabled?: boolean;
}

export const EventLocationDropdown: React.FunctionComponent<Props> = ({
  name,
  label,
  task,
  disabled,
}) => {
  return (
    <SelectFieldTask
      name={name}
      label={label}
      task={task}
      disabled={disabled}
      mapper={(result: LocationData[]): SelectFieldOption[] =>
        result.map(({ locationName, id }) => ({
          name: locationName,
          value: id.toString(),
        }))
      }
    />
  );
};



// WEBPACK FOOTER //
// ./view/components/details/event-details/event-location-details/event-location-dropdown.component.tsx